import lodash from 'lodash';
import deepdash from 'deepdash';

const _ = deepdash(lodash);

var compactModule = function (moduleData) {
    let vectorToSubmit = _.cloneDeep(moduleData);
    delete vectorToSubmit.children;
    if(!vectorToSubmit.extension) {
        return vectorToSubmit;
    }


    const lists = ['actions', 'documents', 'flows', 'logicServices',
        'menus', 'notifications', 'states', 'triggers',
        'authorizations'];

    const informationList = ['connectionField', 'connectionId',
        'description', 'extra', 'displayKey', 'uniqueKey'];

    const toRemoveList = ['connectionModel', 'connectionFieldModel']

    if (vectorToSubmit.extension['information']) {
        vectorToSubmit.extension['information'].forEach(row => {
            informationList.forEach(field => {
                if (row[field] == null || row[field] == false) {
                    delete row[field];
                }
            });

            toRemoveList.forEach(field => {
                delete row[field];
            });

            if (row.fields) {
                row.fields.forEach(tableField => {
                    informationList.forEach(columnField => {
                        if (tableField[columnField] == null || tableField[columnField] == false) {
                            delete tableField[columnField];
                        }
                    });

                    toRemoveList.forEach(field => {
                        delete tableField[field];
                    });
                });
            }

            delete row['columns'];
        });
    }

    lists.forEach(fieldList => {
        if (vectorToSubmit.extension[fieldList] == null
            || vectorToSubmit.extension[fieldList].length == 0) {
            delete vectorToSubmit.extension[fieldList];
        }
    });

    return vectorToSubmit;
}


export default {
    compactModule: compactModule
}